import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
// styles
import "../../../../assets/saas/atoms/_form-field.scss";
import "../../../../assets/saas/atoms/_form-select.scss";
import Select from 'react-select';
import CountryFlagSvg from "country-list-with-dial-code-and-flag/dist/flag-svg";
const PhoneField = ({ phone, phoneCode, phoneError, isPhoneFocused, flag, sortedCountries, setPhone, setPhoneCode, setIsPhoneFocused, isValidPhone, ChangeFlag, id, selectedCountryFlag, setSelectedCountryFlag, }) => {
    const { t } = useTranslation();
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            // Blur all input fields on Enter key press
            document.querySelectorAll("input").forEach((input) => input.blur());
        }
    };
    const selectStyles = {
        control: (base) => ({
            ...base,
            appearance: 'none',
            border: 'none',
            width: "max-content",
            minHeight: '0px',
            height: "35px",
            boxShadow: 'none', // removes focus ring
            backgroundColor: 'transparent', // optional, if needed
            cursor: 'pointer',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        input: (base) => ({
            ...base,
            caretColor: 'transparent', // 👈 hides blinking cursor
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999, // Ensure the menu appears above other elements
        }),
    };
    const options = sortedCountries.map((country) => ({
        value: country.code,
        label: (_jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [_jsx("div", { className: "flag-country", dangerouslySetInnerHTML: { __html: CountryFlagSvg[country.code] } }, phoneCode), country.dial_code] })),
        phoneCode: country.dial_code,
    }));
    return (_jsx("div", { className: `form-field ${phoneError ? " form--error" : ""}`, children: _jsxs("div", { className: `form-field__selected-countary country-code ${phoneError ? "form--error" : ""}`, children: [_jsx(Select, { className: "form-select form-select--border", name: "number", value: options.find(option => option.value === selectedCountryFlag), id: id, onChange: (selected) => {
                        if (selected) {
                            setPhoneCode(selected.phoneCode);
                            ChangeFlag(selected.value);
                            if (setSelectedCountryFlag) {
                                setSelectedCountryFlag(selected.value);
                            }
                        }
                    }, styles: selectStyles, options: options, isSearchable: false }), _jsx("span", { className: `form-select__select-line ${phoneError ? " form--error" : ""}` }), _jsxs("div", { className: "form-field__input-fold form-field__input-fold--phone", id: "phone_fold", children: [_jsx("label", { className: "form-field__form-label", htmlFor: "text", style: isPhoneFocused || phone ? { display: "block" } : { display: "none" }, children: t("label_phone") }), _jsx("input", { autoComplete: "tel", className: "form-field__form-input", type: "tel", inputMode: 'tel', placeholder: t("label_phone"), required: true, value: phone, onChange: (e) => {
                                const digitsOnly = e.target.value.replace(/\D/g, "");
                                setPhone(digitsOnly);
                                isValidPhone(digitsOnly);
                            }, onFocus: () => {
                                setIsPhoneFocused(true);
                            }, onBlur: () => {
                                setIsPhoneFocused(false);
                                // Only update state if the value actually needs cleaning.
                                // Unnecessary setPhone() during blur causes a re-render that
                                // on iOS Safari can swallow the subsequent touch event on
                                // BOOK NOW (the DOM node is recreated mid-event dispatch).
                                const cleanedPhone = phone.replace(/[^\d]/g, "");
                                if (cleanedPhone !== phone) {
                                    setPhone(cleanedPhone);
                                }
                                isValidPhone(cleanedPhone);
                            }, onKeyDown: handleKeyDown })] })] }) }));
};
export default PhoneField;
